import moduleName from '../moduleName';

export default {
  SITES: `${moduleName}/sites`,
  SITE: `${moduleName}/site`,
  SELECTED_ID: `${moduleName}/selectedId`,
  SELECTED: `${moduleName}/selected`,
};
